import { MonthAvailability } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { formatTimeIntervalForAvailabilityInfo } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/DurationsRule/formatTimeIntervalForAvailabilityInfo';
import { getAvailabilityTextForOneTimeUseCases } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/DurationsRule/getAvailabilityTextForOneTimeUseCases';
import { getAvailabilityTextForRefreshUseCases } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/DurationsRule/getAvailabilityTextForRefreshUseCases';
import { getDaysOfWeekText } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/DurationsRule/getDaysOfWeekText';
import { getMonthMealCreditText } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/DurationsRule/getMonthMealCreditText';
import {
  getFormattedDate,
  MealCreditInfoTextProps,
} from 'src/components/oneCorp/features/MealCredit/utils/constructMealCreditInfoText.utils';
import { isDurationRuleValid } from 'src/components/oneCorp/features/MealCredit/utils/isDurationRuleValid';

export function getDurationsAvailabilityInfo(
  values: MealCreditInfoTextProps
): string {
  const {
    startDate,
    endTimeFullDate,
    selectedDays,
    expirationDate,
    isRepeating,
    isDailyLengthBudget,
    isWeeklyLengthBudget,
    isMonthlyLengthBudget,
    budgetResetType,
    budgetLength,
    budgetResetPeriod,
    errors = {},
    expiresOn,
    timeIntervalType,
    refreshPeriodDaysCount,
    isMonthAvailable,
    monthAvailableOn,
    monthAvailableTo,
  } = values;

  if (
    !isDurationRuleValid({
      startDate,
      endTimeFullDate,
      errors,
      budgetResetPeriod,
      budgetResetType,
      budgetLength,
      expirationDate,
      expiresOn,
      isRepeating,
      refreshPeriodDaysCount,
      monthAvailableTo,
    })
  ) {
    return '';
  }

  const formattedDate = getFormattedDate(startDate);
  const formattedTimeInterval = formatTimeIntervalForAvailabilityInfo({
    startDate,
    endTimeFullDate,
    timeIntervalType,
  });

  const daysOfTheWeek = getDaysOfWeekText({
    selectedDays,
    isRepeating,
    budgetResetType,
    budgetResetPeriod,
    isMonthAvailable,
    monthAvailableOn,
  });

  const monthMealCreditText = getMonthMealCreditText({
    monthAvailableOn,
    monthAvailableTo,
    isRepeating,
    startDate,
    selectedDays,
    timeIntervalType,
  });

  const paramsForCreditTypeText = {
    budgetLength,
    budgetResetPeriod,
    isDailyLengthBudget,
    isWeeklyLengthBudget,
    isMonthlyLengthBudget,
    budgetResetType,
  };

  const oneTimeTextLowercase = getAvailabilityTextForOneTimeUseCases(
    paramsForCreditTypeText
  ).toLowerCase();
  const refreshTextLowercase = getAvailabilityTextForRefreshUseCases(
    paramsForCreditTypeText
  ).toLowerCase();
  const oneTimeRefreshText = isRepeating
    ? `recurring credit ${refreshTextLowercase} starting from `
    : `${oneTimeTextLowercase} starts on `;

  const formattedExpirationDate = expirationDate
    ? ` to ${getFormattedDate(expirationDate)}`
    : '';

  return `This ${oneTimeRefreshText}${formattedDate}${formattedExpirationDate}. Orders paid for with this credit can arrive ${formattedTimeInterval}${
    (!isRepeating && isDailyLengthBudget) ||
    monthAvailableOn === MonthAvailability.ON_SPECIFIC_DAY
      ? ''
      : daysOfTheWeek
  }${isMonthAvailable ? monthMealCreditText : ''}.`;
}
